<template>
  <div class="LineForest" v-show="params.flag">
    <div class="line-box box1">
      <div class="name">{{ objsList[3].name }}</div>
      <div class="cont">
        <div class="item-con" v-for="index in 3" :key="index">
          <div class="time item">
            {{
              $moment(sevenData[objsList[3].county].foretime[index]).format(
                'MM/DD',
              )
            }}
          </div>
          <div class="icon item">
            <img
              class="image"
              :src="
                require(
                  '../assets/images/weatherIcon_p/' +
                    sevenData[objsList[3].county].icons_l[index - 1] +
                    '.png',
                )
              "
              alt=""
            />
          </div>
          <div class="dec item">
            {{ sevenData[objsList[3].county].desc_l[index - 1] }}
          </div>
          <div class="temp item">
            {{
              sevenData[objsList[3].county].mint[index] +
              '~' +
              sevenData[objsList[3].county].maxt[index - 1]
            }}℃
          </div>
          <div class="windd item">
            {{ sevenData[objsList[3].county].windd[index] }}
          </div>
          <div class="winds item">
            {{ sevenData[objsList[3].county].winds[index] }}
          </div>
        </div>
      </div>
    </div>
    <div class="line-box box2">
      <div class="name">{{ objsList[2].name }}</div>
      <div class="cont">
        <div class="item-con" v-for="index in 3" :key="index">
          <div class="time item">
            {{
              $moment(sevenData[objsList[2].county].foretime[index]).format(
                'MM/DD',
              )
            }}
          </div>
          <div class="icon item">
            <img
              class="image"
              :src="
                require(
                  '../assets/images/weatherIcon_p/' +
                    sevenData[objsList[2].county].icons_l[index - 1] +
                    '.png',
                )
              "
              alt=""
            />
          </div>
          <div class="dec item">
            {{ sevenData[objsList[2].county].desc_l[index - 1] }}
          </div>
          <div class="temp item">
            {{
              sevenData[objsList[2].county].mint[index] +
              '~' +
              sevenData[objsList[2].county].maxt[index - 1]
            }}℃
          </div>
          <div class="windd item">
            {{ sevenData[objsList[2].county].windd[index] }}
          </div>
          <div class="winds item">
            {{ sevenData[objsList[2].county].winds[index] }}
          </div>
        </div>
      </div>
    </div>
    <div class="line-box box3">
      <div class="name">{{ objsList[1].name }}</div>
      <div class="cont">
        <div class="item-con" v-for="index in 3" :key="index">
          <div class="time item">
            {{
              $moment(sevenData[objsList[1].county].foretime[index]).format(
                'MM/DD',
              )
            }}
          </div>
          <div class="icon item">
            <img
              class="image"
              :src="
                require(
                  '../assets/images/weatherIcon_p/' +
                    sevenData[objsList[1].county].icons_l[index - 1] +
                    '.png',
                )
              "
              alt=""
            />
          </div>
          <div class="dec item">
            {{ sevenData[objsList[1].county].desc_l[index - 1] }}
          </div>
          <div class="temp item">
            {{
              sevenData[objsList[1].county].mint[index] +
              '~' +
              sevenData[objsList[1].county].maxt[index - 1]
            }}℃
          </div>
          <div class="windd item">
            {{ sevenData[objsList[1].county].windd[index] }}
          </div>
          <div class="winds item">
            {{ sevenData[objsList[1].county].winds[index] }}
          </div>
        </div>
      </div>
    </div>
    <div class="line-box box4">
      <div class="name">{{ objsList[0].name }}</div>
      <div class="cont">
        <div class="item-con" v-for="index in 3" :key="index">
          <div class="time item">
            {{
              $moment(sevenData[objsList[0].county].foretime[index]).format(
                'MM/DD',
              )
            }}
          </div>
          <div class="icon item">
            <img
              class="image"
              :src="
                require(
                  '../assets/images/weatherIcon_p/' +
                    sevenData[objsList[0].county].icons_l[index - 1] +
                    '.png',
                )
              "
              alt=""
            />
          </div>
          <div class="dec item">
            {{ sevenData[objsList[0].county].desc_l[index - 1] }}
          </div>
          <div class="temp item">
            {{
              sevenData[objsList[0].county].mint[index] +
              '~' +
              sevenData[objsList[0].county].maxt[index - 1]
            }}℃
          </div>
          <div class="windd item">
            {{ sevenData[objsList[0].county].windd[index] }}
          </div>
          <div class="winds item">
            {{ sevenData[objsList[0].county].winds[index] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { apiData } from '../api/index'
export default {
  props: ['params'],
  data () {
    return {
      sevenData: {}
    }
  },
  computed: {
    ...mapState('home', ['objsList']),
    alarmArr () {
      return this.alarmArea && this.newestAlarms[this.alarmArea]
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const result = await apiData.querySevenDayData()
      this.sevenData = result
    }
  }
}
</script>

<style lang="less" scoped>
.line-box {
  position: fixed;
  top: 20vh;
  left: 28vw;
  z-index: 9;
  color: #fff;
  background: #165184;
  box-shadow: 0 0.1vw 0.89vw 0 #00000073, inset 0vw 0vw 4.01vw 0vw #64b8f8;
  border-radius: 0.63vw;
  font-size: 0.73vw;
  .name {
    height: 2.08vw;
    line-height: 2.08vw;
    font-size: 0.9vw;
    text-align: center;
    background: #0c4170;
    border-top-left-radius: 0.63vw;
    border-top-right-radius: 0.63vw;
  }
  .cont {
    display: flex;
    .item-con {
      width: 4vw;
      .item {
        width: 100%;
        height: 1.56vw;
        display: flex;
        justify-content: center;
        align-items: center;
        .image {
          width: 1.56vw;
        }
      }
    }
  }
}
.box2 {
  top: 55vh;
}
.box3 {
  left: 60vw;
}
.box4 {
  top: 55vh;
  left: 60vw;
}
</style>
